module.exports = __webpack_public_path__ + "img/blue-message.51438f1c.svg";